<template>
    <OverlayLoader :isLoading="!profilesLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.profiles')"
                />

                <WhiteTable :labels="[$translate.text('general.name')]">
                    <template slot="table-data">
                        <tr v-for="profile in profiles" :key="profile.id">
                            <td>{{ profile.name }}</td>
                            <td class="align-right">
                                <i class="fal fa-edit" @click="$router.push({ name: 'Admin Profiles Edit', params: { id: profile.id } })"></i>
                                <i class="fal fa-random" @click="$router.push({ name: 'Admin Profiles Combine', params: { id: profile.id } })"></i>
                                <i class="fal fa-trash-alt" @click="deleteProfile(profile.id)"></i>
                            </td>
                        </tr>
                        <tr v-if="!profiles.length">
                            <td colspan="3">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Admin Profiles Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';

export default {
    name: 'Profiles',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
    },

    data() {
        return {
            profiles: [],
            profilesLoaded: false,
        };
    },

    created() {
        this.getProfiles();
    },

    methods: {

        getProfiles() {
            this.API.admin.profiles.index()
                .then((response) => {
                    const data = response.data.data;
                    this.profiles = data;
                    this.profilesLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        deleteProfile(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.admin.profiles.destroy(id)
                        .then(() => {
                            this.getProfiles();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }
</style>
